module.exports = __webpack_public_path__ + "img/mb-banner.03440ff.jpg";